import { track } from "~/modules/analytics/track";
import { MediaCitationsUserEvents } from "~/modules/analytics/events/media_citations";

// // // //

/**
 * trackChangePublisherFilter
 * Tracks selecting or deselecting a publisher facet in the citations sidebar
 * @param {string} props.publisher - The publisher facet that was clicked
 * @param {boolean} props.selected - Whether the facet is selected after the click
 */
export function trackChangePublisherFilter(props: {
    publisher: string;
    selected: boolean;
}) {
    track(MediaCitationsUserEvents.ChangePublisherFilter, props);
}

/**
 * trackChangeTypeFilter
 * Tracks changing the citation type dropdown on the citations page
 */
export function trackChangeTypeFilter(props: {
    prevValue: string;
    nextValue: string;
}) {
    track(MediaCitationsUserEvents.ChangeTypeFilter, props);
}

/**
 * trackChangeSort
 * Tracks changing the sort dropdown on the citations page
 */
export function trackChangeSort(props: {
    prevValue: string;
    nextValue: string;
}) {
    track(MediaCitationsUserEvents.ChangeSort, props);
}

/**
 * trackClearFilters
 * Tracks resetting the citations page filters
 * @param {string} props.source - Where the clear action was triggered from
 */
export function trackClearFilters(props: { source: "header" | "empty-state" }) {
    track(MediaCitationsUserEvents.ClearFilters, props);
}
